<h1>
  <span class="card_icon k-icon k-i-home k-color-primary k-icon-md" (click)="Home()"></span>
  VALVE (THIS IS JUST DUMMY DATA AND NOT READY FOR USE AT THIS MOMENT)
</h1>


<kendo-grid [kendoGridBinding]="gridValveData"
            [pageSize]="1000"
            [pageable]="true"
            [sortable]="true"
            [groupable]="true"
            [reorderable]="true"
            [resizable]="true"
            [group]="group"
            [sortable]="{ mode: 'multiple' }"
            [pageable]="true"
            [columnMenu]="{ filter: true }"
>
  <ng-template kendoGridToolbarTemplate>

    <kendo-grid-spacer></kendo-grid-spacer>
    <button kendoGridExcelCommand type="button" icon="file-excel">
      Export to Excel
    </button>
    <button kendoGridPDFCommand icon="file-pdf">Export to PDF</button>
  </ng-template>

  <kendo-grid-column
    field="unit"
    title="unit"
    [width]="100"
    [class]="{ 'text-center': true }"
    [resizable]="false"
  ></kendo-grid-column>


  <kendo-grid-column field="recipe_ref_nr" title="Recipe" [width]="100" ></kendo-grid-column>

  <kendo-grid-column field="valve" title="Valve" [width]="150" > </kendo-grid-column>

  <kendo-grid-column field="start_time" title="Start day ">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ EpochToTime(dataItem.start_time) | date:  "dd/MM/YY"  }}
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column field="start_time" title="Start time ">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ EpochToTime(dataItem.start_time) | date:  "hh:mm:ss"  }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="end_time" title="End time">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ EpochToTime(dataItem.end_time) | date: "hh:mm:ss"  }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="target_time" title="Time Target"></kendo-grid-column>
  <kendo-grid-column field="realised_time" title="Time Actual"></kendo-grid-column>

  <kendo-grid-column field="target_volume_ml" title="Dosage Target">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ MlToLiters (dataItem.target_volume_ml )  }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="realised_volume_ml" title="Dosage Realised">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ MlToLiters( dataItem.realised_volume_ml)  }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="target_ec" title="EC">

    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.target_ec | number: "1.1-1"  }}
    </ng-template>

  </kendo-grid-column>
  <kendo-grid-column field="realised_ec" title="EC">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.realised_ec | number: "1.1-1"  }}
    </ng-template>


  </kendo-grid-column>

  <kendo-grid-column field="target_ph" title="ph">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.target_ph | number: "1.1-1"  }}
    </ng-template>


  </kendo-grid-column>
  <kendo-grid-column field="realised_ph" title="ph">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.realised_ph | number: "1.1-1"  }}
    </ng-template>


  </kendo-grid-column>

<!--  <kendo-grid-column  title="summation">-->
<!--      <ng-template-->
<!--        kendoGridGroupHeaderColumnTemplate-->
<!--        let-group="group"-->
<!--        let-aggregates="aggregates"-->
<!--      >-->
<!--            <span title="Group Header Column Template for valve">-->
<!--              Sum: {{ MlToLiters (aggregates.realised_volume_ml.sum)  }}-->
<!--            </span>-->
<!--      </ng-template>-->
<!--  </kendo-grid-column>-->

  <kendo-grid-pdf
    fileName="sercom.pdf"
    [repeatHeaders]="true"
    [allPages]="true"
  ></kendo-grid-pdf>

  <kendo-grid-excel
    fileName="sercom.xlsx"
    [fetchData]="allData"
  >  </kendo-grid-excel>

</kendo-grid>

